import { replace, forEach } from "lodash";

export const prepareUrl = (url, params) => {
  forEach(params, (param, key) => {
    url = replace(url, `:${key}`, param);
  });
  return url;
};
